import type { GoalsTimingSection } from '../../../types';

interface GoalTimingPanelProps {
  timing: GoalsTimingSection;
}

export function GoalTimingPanel({ timing }: GoalTimingPanelProps) {
  const formatPct = (ratio: number | null) => {
    if (ratio === null) return '--%';
    return `${(ratio * 100).toFixed(0)}%`;
  };

  const TeamTiming = ({ team, label }: { team: typeof timing.home; label: string }) => (
    <div className="goals-timing-team">
      <h5>{label}</h5>
      <div className="goals-timing-bars">
        <div className="goals-timing-bar">
          <span className="goals-timing-label">1st Half</span>
          <div className="goals-timing-bar-track">
            <div
              className="goals-timing-bar-fill goals-timing-fh"
              style={{ width: formatPct(team.first_half.ratio) }}
            />
          </div>
          <span className="goals-timing-value">{formatPct(team.first_half.ratio)}</span>
        </div>
        <div className="goals-timing-bar">
          <span className="goals-timing-label">2nd Half</span>
          <div className="goals-timing-bar-track">
            <div
              className="goals-timing-bar-fill goals-timing-sh"
              style={{ width: formatPct(team.second_half.ratio) }}
            />
          </div>
          <span className="goals-timing-value">{formatPct(team.second_half.ratio)}</span>
        </div>
      </div>
      <div className="goals-timing-stats">
        <div className="goals-timing-stat">
          <span>FH Goals For</span>
          <span>{team.first_half.goals_for || 0}</span>
        </div>
        <div className="goals-timing-stat">
          <span>SH Goals For</span>
          <span>{team.second_half.goals_for || 0}</span>
        </div>
      </div>
    </div>
  );

  return (
    <div className="goals-panel goals-timing-panel">
      <h4>Goal Timing Distribution</h4>
      <div className="goals-timing-grid">
        <TeamTiming team={timing.home} label="Home Team" />
        <TeamTiming team={timing.away} label="Away Team" />
      </div>
    </div>
  );
}

export default GoalTimingPanel;
